// extracted by mini-css-extract-plugin
module.exports = {"container":"ManualPay_container__4vCDj","label":"ManualPay_label__2lDEl","handle":"ManualPay_handle__3xTez","reason":"ManualPay_reason__OqKXM","content":"ManualPay_content__23ds4"};